import styled, { css } from 'styled-components';
import { rem } from 'polished';

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const StyledTHead = styled.thead`
  border-bottom: ${rem('2px')} solid ${props => props.theme.colors.dark};
`;

const StyledRow = styled.tr`
  width: 100%;
`;

const borders = css`
  border-bottom: ${rem('1px')} ${props => props.theme.colors.grayLighter} solid;
  border-left: ${rem('1px')} ${props => props.theme.colors.grayLighter} solid;
  border-right: ${rem('1px')} ${props => props.theme.colors.grayLighter} solid;
`;

const StyledTBody = styled.tbody`
  background-color: ${props => props.theme.colors.grayMoreLight};

  ${StyledRow} {
    ${borders}
  }
`;

const StyledTFoot = styled.tfoot`
  background-color: ${props => props.theme.colors.grayMoreLight};

  ${StyledRow} {
    ${borders}
  }
`;

const StyledCell = `
  font-size: ${rem('14px')};
  color: ${props => props.theme.colors.dark};
`;

const StyledCellTh = styled.th`
  ${StyledCell}
  font-family: ${props => props.theme.fonts.medium};
  padding-left: ${rem('18px')};
  padding-bottom: ${rem('8px')}; 
  text-align: left;
  font-weight: 500;
`;

const StyledCellTd = styled.td`
  ${StyledCell}
  font-family: ${props => props.theme.fonts.book};
  padding: ${rem('8px')} 0 ${rem('8px')} ${rem('18px')};
`;

export {
  StyledTable,
  StyledTHead,
  StyledTBody,
  StyledTFoot,
  StyledRow,
  StyledCell,
  StyledCellTh,
  StyledCellTd
};
